// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mfe-beh-smart-groups-consequence_view_body {
  height: auto;
  flex-shrink: 0;
  max-width: 460px !important;
  min-width: 460px !important;
}

.mfe-beh-smart-groups-consequence_view_body_parent {
  display: inline-flex;
  align-items: flex-start;
  gap: 11px;
  width: 100%;
}

.mfe-beh-smart-groups-crstr_student_name {
  padding-bottom: 18px;
  border-bottom: none !important;
  min-width: 460px;
}

.mfe-beh-smart-groups-crstr_student_name span {
  color: #000;
  font: var(--neon-2_15_0-font-3);
  font-weight: 500;
}

.mfe-beh-smart-groups-consequence_view_body__left_section {
  display: flex;
  padding: 10px 0px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
}

.mfe-beh-smart-groups-consequence_view_body__left_section p {
  color: var(--text-color-light, #677274);
  font: var(--neon-2_15_0-font-1);
  margin: 0px;
  /* 150% */
}

.mfe-beh-smart-groups-consequence_view_body__right_section {
  display: flex;
  padding: 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
  border-radius: 4px;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
  height: 42px;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header_child {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
  width: 100%;
  justify-content: space-between;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_p {
  display: flex;
  max-width: 287px;
  height: 20px;
  flex-direction: column;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_p_left {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_p_left span {
  color: var(--text-color-dark, #333);
  font: var(--neon-2_15_0-font-2);
  font-weight: var(--neon-2_15_0-font-weight-medium);
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_p_right {
  display: flex;
  padding: 4px;
  align-items: flex-start;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid var(--global-border, #C4C9CA);
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_p_right span {
  color: var(--text-color-dark, #333);
  font: var(--neon-2_15_0-font-2);
  font-weight: var(--neon-2_15_0-font-weight-medium);
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_c {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_header__text_c span {
  color: var(--text-color-light, #677274);
  font: var(--neon-2_15_0-font-1);
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_body {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
}

.mfe-beh-smart-groups-consequence_view_body__right_section_notes_body span {
  color: var(--common-global-dark-text, #333);
  font: var(--neon-2_15_0-font-2);
  line-height: 21px;
}

.mfe-beh-smart-groups-view_behavior_loader {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  width: 100%;
}

.mfe-beh-smart-groups-line-after-iteration {
  height: 1px;
  background: #DFE2E2;
  width: 100%;
  margin-top: 7px;
  margin-bottom: 3px;
}

.mfe-beh-smart-groups-view_behavior_error {
  margin-top: 59px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mfe-beh-smart-groups-view_behavior_error_heading {
  color: var(--text-color-dark, #333);
  /* Typography/\$font-size-2/14px medium */
  font: var(--neon-2_15_0-font-2);
  font-weight: 500;
}

.mfe-beh-smart-groups-view_behavior_error_content {
  margin-top: 4px;
  font: var(--neon-2_15_0-font-2);
  color: var(--text-color-light, #677274);
}

.mfe-beh-smart-groups-view_behavior_error_content span {
  font: var(--neon-2_15_0-font-2);
  color: var(--text-color-link, #1162EE);
}`, "",{"version":3,"sources":["webpack://./components/smart-groups/smart-group-table/smart-group-view-student-behavior/smart-group-view-student-behavior.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,cAAA;EACA,2BAAA;EACA,2BAAA;AACJ;;AAEA;EACI,oBAAA;EACA,uBAAA;EACA,SAAA;EACA,WAAA;AACJ;;AAEA;EACI,oBAAA;EACA,8BAAA;EACA,gBAAA;AACJ;;AAGA;EACI,WAAA;EACA,+BAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,aAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,qBAAA;AAAJ;;AAIA;EACI,uCAAA;EACA,+BAAA;EACA,WAAA;EACA,SAAA;AADJ;;AAIA;EACI,aAAA;EACA,YAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AADJ;;AAKA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAFJ;;AAKA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,aAAA;EACA,gBAAA;EACA,YAAA;EAEA,sBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAHJ;;AAMA;EACI,mCAAA;EACA,+BAAA;EACA,kDAAA;AAHJ;;AAMA;EACI,aAAA;EACA,YAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,+CAAA;AAHJ;;AAMA;EACI,mCAAA;EACA,+BAAA;EACA,kDAAA;AAHJ;;AAMA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAHJ;;AAMA;EACI,uCAAA;EACA,+BAAA;AAHJ;;AAOA;EACI,aAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AAJJ;;AAOA;EACI,2CAAA;EACA,+BAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AAJJ;;AAOA;EACI,WAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,mCAAA;EAEA,wCAAA;EACA,+BAAA;EACA,gBAAA;AALJ;;AAQA;EACI,eAAA;EACA,+BAAA;EACA,uCAAA;AALJ;;AAQA;EACI,+BAAA;EACA,sCAAA;AALJ","sourcesContent":[".__mfe__consequence_view_body {\n    height: auto;\n    flex-shrink: 0;\n    max-width: 460px!important;\n    min-width: 460px!important;\n}\n\n.__mfe__consequence_view_body_parent {\n    display: inline-flex;\n    align-items: flex-start;\n    gap: 11px;\n    width: 100%;\n}\n\n.__mfe__crstr_student_name {\n    padding-bottom: 18px;\n    border-bottom: none !important;\n    min-width: 460px;\n\n}\n\n.__mfe__crstr_student_name span {\n    color: #000;\n    font: var(--__neon__font-3);\n    font-weight: 500;\n}\n\n.__mfe__consequence_view_body__left_section {\n    display: flex;\n    padding: 10px 0px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: flex-end;\n    // margin-top: 5px;\n}\n\n.__mfe__consequence_view_body__left_section p {\n    color: var(--text-color-light, #677274);\n    font: var(--__neon__font-1);\n    margin: 0px;\n    /* 150% */\n}\n\n.__mfe__consequence_view_body__right_section {\n    display: flex;\n    padding: 8px;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n    flex: 1 0 0;\n    border-radius: 4px;\n    // max-width: 350px;\n}\n\n.__mfe__consequence_view_body__right_section_notes_header {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 4px;\n    align-self: stretch;\n    height: 42px;\n}\n\n.__mfe__consequence_view_body__right_section_notes_header_child {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    gap: 4px;\n    flex: 1 0 0;\n    width: 100%;\n    justify-content: space-between;\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_p {\n    display: flex;\n    max-width: 287px;\n    height: 20px;\n    // align-items: center;\n    flex-direction: column;\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_p_left {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_p_left span {\n    color: var(--text-color-dark, #333);\n    font: var(--__neon__font-2);\n    font-weight: var(--__neon__font-weight-medium);\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_p_right {\n    display: flex;\n    padding: 4px;\n    align-items: flex-start;\n    gap: 10px;\n    border-radius: 4px;\n    border: 1px solid var(--global-border, #C4C9CA);\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_p_right span {\n    color: var(--text-color-dark, #333);\n    font: var(--__neon__font-2);\n    font-weight: var(--__neon__font-weight-medium);\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_c {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    align-self: stretch;\n}\n\n.__mfe__consequence_view_body__right_section_notes_header__text_c span {\n    color: var(--text-color-light, #677274);\n    font: var(--__neon__font-1);\n}\n\n\n.__mfe__consequence_view_body__right_section_notes_body {\n    display: flex;\n    align-items: flex-start;\n    gap: 10px;\n    align-self: stretch;\n}\n\n.__mfe__consequence_view_body__right_section_notes_body span {\n    color: var(--common-global-dark-text, #333);\n    font: var(--__neon__font-2);\n    line-height: 21px;\n}\n\n.__mfe__view_behavior_loader {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-top: 30px;\n    width: 100%;\n}\n\n.__mfe__line-after-iteration {\n    height: 1px;\n    background: #DFE2E2;\n    width: 100%;\n    margin-top: 7px;\n    margin-bottom: 3px;\n}\n\n.__mfe__view_behavior_error {\n    margin-top: 59px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.__mfe__view_behavior_error_heading {\n    color: var(--text-color-dark, #333);\n\n    /* Typography/$font-size-2/14px medium */\n    font: var(--__neon__font-2);\n    font-weight: 500;\n}\n\n.__mfe__view_behavior_error_content {\n    margin-top: 4px;\n    font: var(--__neon__font-2);\n    color: var(--text-color-light, #677274);\n}\n\n.__mfe__view_behavior_error_content span {\n    font: var(--__neon__font-2);\n    color: var(--text-color-link, #1162EE);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
